import { DraggableWidget } from '@/components/ui/DraggableWidget'
import { useDialpad } from './useDialpad'

/**
 * The Dialpad Mini Dialer (Open CTI) iframe. Mounted ONCE at the layout level
 * so React Router navigation never tears it down — that would drop an
 * in-progress call. Wrapped in DraggableWidget so staff can move it out of the
 * way; expanded/collapsed is a visibility toggle so the iframe (and any live
 * call) keeps running underneath.
 *
 * The `allow` / `sandbox` attributes are mandated by Dialpad — `hid` and
 * `microphone` in particular are required for WebRTC audio + headset controls.
 */
export function DialpadWidget() {
  const ctx = useDialpad()
  if (!ctx || ctx.status !== 'ready') return null
  return (
    <DraggableWidget name="dialpad" width={400} height={600} visible={ctx.expanded} onHide={ctx.collapse}>
      <iframe
        id={ctx.widgetContainerId}
        title="Dialpad"
        src={ctx.iframeSrc}
        allow="microphone; speaker-selection; autoplay; camera; display-capture; hid"
        sandbox="allow-popups allow-scripts allow-same-origin allow-forms"
        style={{ display: 'block', width: '100%', height: '100%', border: 'none' }}
      />
    </DraggableWidget>
  )
}
